<template>
  <div id="pcb-cost-estimator">
    <div class="message warning">* The price uses CNY currency.</div>
    <Form  ref="pcbCostEstimatorForm" :model="formData" inline>
      <Row :gutter="32" class="text-align-center">
        <Col span="8">
          <FormItem label="Quantity" prop="quantity">
            <Input v-model="formData.quantity" number />
          </FormItem>
        </Col>
        <Col span="8">
          <FormItem label="Lead time" prop="lead_time">
            <Input v-model="formData.lead_time" number /> <span>working days</span>
          </FormItem>
        </Col>
        <Col span="8">
          <FormItem label="Impedance test" prop="impedance_test">
            <Select v-model="formData.impedance_test">
              <Option value="yes">Yes</Option>
              <Option value="no">No</Option>
            </Select>
          </FormItem>
        </Col>
      </Row>
      <Row :gutter="32" class="text-align-center">
        <Col span="8">
          <FormItem label="Service fee" prop="service_fee">
            <Input v-model="formData.service_fee" number />
          </FormItem>
        </Col>
        <Col span="8">
          <FormItem label="Proofing fee" prop="proofing_fee">
            <Input v-model="formData.proofing_fee" number />
          </FormItem>
        </Col>
        <Col span="8">
          <FormItem label="Different designs fee" prop="different_designs_fee">
            <Input v-model="formData.different_designs_fee" number />
          </FormItem>
        </Col>
      </Row>
      <Row :gutter="32" class="text-align-center">
        <Col span="8">
          <FormItem label="Shipment cost" prop="shipment_cost">
            <Input v-model="formData.shipment_cost" number />
          </FormItem>
        </Col>
        <Col span="8">
          <FormItem label="Margin" prop="margin">
            <InputNumber class="inline" v-model="formData.margin" :formatter="(value) => value * 100">
            </InputNumber> <span>%</span>
          </FormItem>
        </Col>
        <Col span="8">
          <FormItem label="Dimension" prop="dimension">
            {{ this.dimensionM2 ? this.dimensionM2.toNumber('m^2').toFixed(5) : 0.0 }} <span>m<sup>2</sup></span>
          </FormItem>
        </Col>
      </Row>
      <Row :gutter="32">
        <Col span="12">
          <div class="title inline">Gross total:</div>
          <span class="value">{{ intlCurrencyNumber(currency, amountTotal, 2, 2) }}</span>
        </Col>
        <Col span="12">
          <div class="title inline">Lead time:</div>
          <span class="value">{{ formData.lead_time }}</span>
          <span class="desc">working days</span>
        </Col>
      </Row>
      <br>
      <br>
      <Row :gutter="32">
        <Col span="8">
          <div class="title inline">Std. lead time:</div>
          <span class="value">{{ formData.std_lead_time }}</span>
          <span class="desc">working days</span>
        </Col>
        <Col span="8">
          <div class="title inline">Price:</div>
          <span class="value">{{ intlCurrencyNumber(currency, price, 2, 2) }}</span>
        </Col>
        <Col span="8">
          <div class="title inline">Shpiment:</div>
          <span class="value">{{ intlCurrencyNumber(currency, formData.shipment_cost, 2, 2) }}</span>
        </Col>
      </Row>
      <div class="actions text-align-right">
        <Button type="warning" size="large" @click="handleTestPrice">Test price without saving</Button> &nbsp;
        <Button type="primary" size="large" @click="handleSaveEstimate" :loading="saving">Submit and save price</Button>
      </div>
    </Form>
  </div>
</template>

<script>
import { intlCurrencyNumber } from '@/libs/util'
import pcbPriceCalculator from '../config/calculator'
import * as CONFIG from '../config/calculation-config'
import { mapActions } from 'vuex'
export default {
  name: 'PcbCostEstimator',
  props: {
    pcbSpecData: {
      type: Object,
      required: false
    }
  },
  data () {
    return {
      formData: {
        quantity: 1,
        margin: 0.2,
        different_designs_fee: 0.0,
        service_fee: CONFIG.serviceFee,
        proofing_fee: CONFIG.proofingFee,
        lead_time: 9,
        std_lead_time: 9,
        impedance_test: 'yes',
        shipment_cost: 0.0,
        urgency: 9,
        currency: 'CNY'
      },
      dimensionM2: null,
      calculated: {},
      price: 0.0,
      amountTotal: 0.0,
      amountWithUrgencyDays: {
        1: 0.0,
        2: 0.0,
        3: 0.0
      },
      currency: 'CNY',
      pcbId: this.$route.params.partId,
      saving: false
    }
  },
  watch: {
    pcbSpecData: {
      deep: true,
      handler () {
        this.calculate()
      }
    },
    '$route.params.partId': () => {
      this.pcbId = this.$route.params.partId
    }
  },
  methods: {
    ...mapActions([
      'createPcbCost'
    ]),
    intlCurrencyNumber,
    calculate: function () {
      this.dimensionM2 = pcbPriceCalculator.getDimension(
        this.formData.quantity,
        this.pcbSpecData.width,
        this.pcbSpecData.height,
        this.pcbSpecData.measurement_unit,
        'm'
      )

      this.calculated = pcbPriceCalculator.calculate(this.dimensionM2, this.pcbSpecData, this.formData)
      this.formData.service_fee = this.calculated['serviceFee']
      this.formData.proofing_fee = this.calculated['proofingFee']
      this.formData.different_designs_fee = this.calculated['differentDesignsFee']

      this.price = pcbPriceCalculator.getPrice(this.calculated['bareCost'], this.formData.margin).toFixed(2)

      this.formData.shipment_cost = pcbPriceCalculator.getShipmentCost(this.dimensionM2)
      this.formData.lead_time = pcbPriceCalculator.getLeadTime(this.pcbSpecData.layers, this.dimensionM2)

      this.amountTotal = Number(this.price) + Number(this.formData.shipment_cost)

      _.map([1, 2, 3], (days) => {
        this.amountWithUrgencyDays[days] = pcbPriceCalculator.getUrgencyCost(this.pcbSpecData.layers, this.dimensionM2, days, this.calculated['bareCost'])
      })
    },
    handleTestPrice: function () {
      this.calculate()
    },
    handleSaveEstimate: function () {
      this.calculate()

      this.saving = true

      const data = Object.assign({}, this.formData, {
        cost: this.calculated['bareCost'],
        dimension: this.dimensionM2.toNumber('m^2'),
        dimension_unit: 'm^2',
        impedance_test: this.formData.impedance_test === 'yes',
        manufacturer_part_id: this.pcbId
      })

      this.createPcbCost(data).then(resp => {
        this.$Message.success('PCB cost estimate has been saved!')
        this.$emit('on-saved', resp.data)
      }).finally(() => {
        this.saving = false
      })
    }
  }
}
</script>

<style lang="less" scoped>
  .title { font-weight: bold; text-transform: uppercase; }
  .value { margin-left: 5px; font-size: 150%; font-weight: bolder; }
  .desc { display: block; }
</style>
